import { render, staticRenderFns } from "./SettingsIndexesFile.vue?vue&type=template&id=51d4e656&"
import script from "./SettingsIndexesFile.vue?vue&type=script&lang=js&"
export * from "./SettingsIndexesFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports